import React from 'react';
import NarrowPage from '../../../../framework/base/common/components/layout/sections/NarrowPage';
import PageHeaderWithMetadata from '../../../../framework/base/common/components/shared/elements/PageHeaderWithMetadata';

interface PortfolioItem {
  file: string;
  label: string;
}

const portfolio: PortfolioItem[] = [
  {
    file: 'Anna Michałowska - Porfolio - 2 - Malarstwo.pdf',
    label: 'Malarstwo',
  },
  {
    file: 'Anna Michałowska - Porfolio - 3 - Rzeźba - 1.pdf',
    label: 'Rzeźba 1',
  },
  {
    file: 'Anna Michałowska - Porfolio - 3 - Rzeźba - 2.pdf',
    label: 'Rzeźba 2',
  },
  {
    file: 'Anna Michałowska - Porfolio - 4 - Kopie, Ubiór, Wnętrza.pdf',
    label: 'Kopie, Ubiór, Wnętrza',
  },
  {
    file: 'Anna Michałowska - Porfolio - 5 - Scenografia - 1.pdf',
    label: 'Scenografia 1',
  },
  {
    file: 'Anna Michałowska - Porfolio - 5 - Scenografia - 2.pdf',
    label: 'Scenografia 2',
  },
  {
    file: 'Anna Michałowska - Porfolio - 5 - Scenografia - 3.pdf',
    label: 'Scenografia 3',
  },
  {
    file: 'Anna Michałowska - Porfolio - 6 - Mozaika, Ceramika, Plakat, Maski, Warsztaty.pdf',
    label: 'Mozaika, Ceramika, Plakat, Maski, Warsztaty',
  },
];

const AboutPage: React.FC = () => (
  <NarrowPage appendClassName='pt-4'>
    <PageHeaderWithMetadata header='O mnie' />
    <section className='pb-4'>
      <h4 className='fw-light'>
        Portfolio
      </h4>
      <ul>
        {portfolio.map((item, index) => (
          <li key={index}>
            <a
              href={`/portfolio/${item.file}`}
              target='_blank'
              rel='noreferrer'
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </section>
    <section className='pb-4'>
      <h4 className='fw-light'>
        Blog
      </h4>
      <a
        href='https://annamichalowska.blogspot.com'
        target='_blank'
        rel='noreferrer'
      >
        https://annamichalowska.blogspot.com
      </a>
    </section>
  </NarrowPage>
);

export default AboutPage;
